import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "barcode"
};
const _hoisted_2 = ["innerHTML"];
import { computed, inject } from 'vue';
import VueBarcode from '@chenfengyuan/vue-barcode';
import ProductAttributeValueIcon from "./ProductAttributeValueIcon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductAttributeValue',
    props: {
        attribute: {},
        value: {},
        valueCode: {}
    },
    setup(__props) {
        const uiConfig = inject('productAttributesUiConfig', { icons: {} });
        const props = __props;
        const icon = computed(() => {
            if (!uiConfig || !props.valueCode) {
                return null;
            }
            const attrConfig = (uiConfig.icons || {})[props.attribute.type];
            if (!attrConfig) {
                return null;
            }
            return attrConfig[props.valueCode] || attrConfig['*'] || null;
        });
        const showValue = computed(() => {
            // assume that we'll have an icon for boolean values (showing '1' or true is not useful)
            // attribute values '0' and false are filtered server-side, by default
            if (props.attribute.dataType === 'bool') {
                return false;
            }
            return !(icon.value && icon.value.hideValue === true);
        });
        return (_ctx, _cache) => {
            return (__props.attribute.dataType === 'code')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_unref(VueBarcode), {
                        tag: "svg",
                        value: __props.value,
                        options: {
                            displayValue: true,
                            format: __props.value && __props.value.length === 8 ? 'EAN8' : 'EAN13',
                            // no idea what kind of unit this is
                            height: 30,
                            // margin 0 will cut a pixel off of the rendered value
                            margin: 1
                        }
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.value), 1)
                        ]),
                        _: 1
                    }, 8, ["value", "options"])
                ]))
                : (__props.attribute.dataType === 'html')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (icon.value)
                            ? (_openBlock(), _createBlock(ProductAttributeValueIcon, {
                                key: 0,
                                icon: icon.value
                            }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        (showValue.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                innerHTML: __props.value
                            }, null, 8, _hoisted_2))
                            : _createCommentVNode("", true)
                    ], 64))
                    : (__props.attribute.dataType === 'date')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (icon.value)
                                ? (_openBlock(), _createBlock(ProductAttributeValueIcon, {
                                    key: 0,
                                    icon: icon.value
                                }, null, 8, ["icon"]))
                                : _createCommentVNode("", true),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            (showValue.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.$date(__props.value)), 1)
                                ], 64))
                                : _createCommentVNode("", true)
                        ], 64))
                        : (__props.attribute.dataType === 'datetime')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                (icon.value)
                                    ? (_openBlock(), _createBlock(ProductAttributeValueIcon, {
                                        key: 0,
                                        icon: icon.value
                                    }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                (showValue.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$dateTime(__props.value)), 1)
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (icon.value)
                                    ? (_openBlock(), _createBlock(ProductAttributeValueIcon, {
                                        key: 0,
                                        icon: icon.value
                                    }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                (showValue.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(__props.value), 1)
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ], 64));
        };
    }
});
